import axios from "axios";
import { ADD_DISTRIBUTOR_EDIT_DISTRIBUTOR, GET_ALL_DISTRIBUTOR, CHANGE_DISTRIBUTOR_STATUS, GET_SINGLE_DISTRIBUTOR_DETAILS, GET_ACTIVE_DISTRIBUTORS } from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";

// <-------------------------DISTRIBUTOR------------------------------------>
// Function for handling add distributor api
export async function handleAddEditDistributorApi(distributorData, token) {
  try {

    let formData = await convertToFormData(distributorData);
    let response = await axios.post(ADD_DISTRIBUTOR_EDIT_DISTRIBUTOR, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });


    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all distributor
export async function getAllDistributorDetailsApi(token, page, itemsPerPage) {
  try {
    const params =  new URLSearchParams();
    params.append('page',page)
    params.append('limit', itemsPerPage)

    let response = await axios.get(`${GET_ALL_DISTRIBUTOR}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


// Function for handling change sub distributor status  api
export async function handleChangeDistributorStatusApi(distId, token) {
  try {

    let response = await axios.patch(`${CHANGE_DISTRIBUTOR_STATUS}/${distId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

export async function fetchSingleDistributorDetailsApi(token , distributorId){
  try{
    try {
  
      let response = await axios.get(`${GET_SINGLE_DISTRIBUTOR_DETAILS}/${distributorId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }catch(error){
    console.log("err", error.message);
    
  }
}

// Function for fetch all active Distributors
export async function  getAllActiveDistributorsApi(token) {
  try {
    let response = await axios.get(GET_ACTIVE_DISTRIBUTORS, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}
